import { onReady } from './utils/on-ready';
import { initWindowResize, onWindowResize } from './utils/window-resize';
import { isTouch, initVhUnitOverwrite } from './utils/helpers';
import { initAnchorScroll } from './utils/scroll';
import { setupNavigation } from './layout/navigation';
import { calculateIframeSize } from './components/iframe-resize';
import { setupLanguageSelector } from './components/language-selector';
import { setupAccordions } from './components/accordion';
import { setupVimeoVideos } from './components/vimeo-video';
import { setupSwipers } from './components/swiper';
import { setupIntersect } from './utils/intersect';
import { setupGalleries } from './components/gallery';

function init() {
    setTimeout(() => {
        document.body.classList.remove('standby');
    }, 0);

    if (isTouch) {
        document.body.classList.add('touch-device');
    }

    initWindowResize();

    onReady(() => {
        initVhUnitOverwrite(calculateIframeSize);
        setupIntersect();
        setupGalleries();
        initAnchorScroll();
        setupNavigation();
        setupLanguageSelector();
        setupAccordions();
        setupSwipers();
        setupVimeoVideos();
    });

    onWindowResize(() => {
        calculateIframeSize();
    });
}

init();
